// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HoPh3","col":"styles_col__2jfQm"};